/* ============================================================
   BDP — animação do preenchimento da barra de desconto progressivo
   A barra ACOMPANHA o valor do carrinho: ao abrir e ao adicionar/
   remover itens, o cobre desliza SUAVEMENTE do valor anterior até o
   novo, rumo ao próximo marco de desconto.

   Técnica: transição CSS no width (via a var --tier-w). Quando um
   fill novo aparece com o carrinho aberto, fixamos o valor ANTERIOR
   sem transição (evita flash), forçamos reflow e transicionamos até
   o valor NOVO. Guarda o último % na sessão da página.
   Só roda com o drawer aberto (trilho com largura). Respeita
   prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';

  var EASE = 'cubic-bezier(0.26, 0.54, 0.32, 1)';
  var DUR = '0.65s';
  var KEY = '__bdpTierLast';

  function reduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function targetOf(fill) {
    var n = parseFloat(fill.style.getPropertyValue('--tier-w') || '0');
    return isNaN(n) ? 0 : n;
  }

  function playFill(fill) {
    var bar = fill.parentElement;
    if (!bar || bar.getBoundingClientRect().width < 1) return; // trilho fechado

    var target = targetOf(fill);
    var last = typeof window[KEY] === 'number' ? window[KEY] : 0;
    window[KEY] = target;

    if (reduced() || Math.abs(target - last) < 0.3) return; // nada a animar

    // começa no valor anterior, sem transição...
    fill.style.transition = 'none';
    fill.style.setProperty('--tier-w', last + '%');
    void fill.offsetWidth; // reflow: fixa o estado inicial
    // ...e desliza até o novo
    fill.style.transition = 'width ' + DUR + ' ' + EASE;
    fill.style.setProperty('--tier-w', target + '%');
  }

  function watch(cd) {
    if (cd.__bdpTierWatch) return;
    cd.__bdpTierWatch = true;

    var lastFillEl = null;

    function scan() {
      if (!cd.classList.contains('active')) {
        lastFillEl = null; // fechou: próxima abertura re-anima
        return;
      }
      var fill = cd.querySelector('.bdp-tier__fill');
      if (fill && fill !== lastFillEl) {
        lastFillEl = fill;
        playFill(fill); // síncrono: define o estado antes do primeiro paint
      }
    }

    scan();
    new MutationObserver(scan).observe(cd, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  function init() {
    document.querySelectorAll('cart-drawer').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
